import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/public/Home";
import Programs from "@/pages/public/Programs";
import ProgramDetail from "@/pages/public/ProgramDetail";
import LearningPaths from "@/pages/public/LearningPaths";
import SegmentPage from "@/pages/public/SegmentPage";
import { Blog, BlogPost } from "@/pages/public/Blog";
import Verify from "@/pages/public/Verify";
import Login from "@/pages/auth/Login";
import Register from "@/pages/auth/Register";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/dashboard/Dashboard";
import CoursePlayer from "@/pages/CoursePlayer";
import AssessmentPlayer from "@/pages/AssessmentPlayer";
import { PaymentSuccess, PaymentCancel } from "@/pages/payment/Payment";

function AppRoutes() {
    const location = useLocation();
    if (location.hash?.includes("session_id=")) return <AuthCallback />;
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/programs" element={<Programs />} />
            <Route path="/programs/:slug" element={<ProgramDetail />} />
            <Route path="/learning-paths" element={<LearningPaths />} />
            <Route path="/for-schools" element={<SegmentPage variant="schools" />} />
            <Route path="/corporate" element={<SegmentPage variant="corporate" />} />
            <Route path="/community" element={<SegmentPage variant="community" />} />
            <Route path="/resources" element={<Blog />} />
            <Route path="/resources/:slug" element={<BlogPost />} />
            <Route path="/verify" element={<Verify />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/learn/:slug" element={<ProtectedRoute><CoursePlayer /></ProtectedRoute>} />
            <Route path="/assessments/:id" element={<ProtectedRoute><AssessmentPlayer /></ProtectedRoute>} />
            <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
        </Routes>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <AppRoutes />
                    <Toaster position="top-right" richColors />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
